export const tr = {
    'sizes-title': 'Boyut'
};
